import { forwardRef } from 'react';
import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { Add16, ChevronDown } from 'ui/icons';
import { Tooltip, TipPlacement } from 'ui/tooltip';
import { useTranslation } from '../hooks';

type InsightSelectTriggerProps = {
  toggleDropdown: () => void;
  isDisabled: boolean;
  placeholder?: string;
};

const TriggerButton = styled(SecondaryButton)`
  align-items: center;
  display: flex;
  font-family: 'Sofia Pro', system-ui, -apple-system, BlinkMacSystemFont, 'Avenir Next', Avenir,
    'Segoe UI', 'Lucida Grande', 'Helvetica Neue', Helvetica, 'Fira Sans', Roboto, Noto,
    'Droid Sans', Cantarell, Oxygen, Ubuntu, 'Franklin Gothic Medium', 'Century Gothic',
    'Liberation Sans', sans-serif;
  font-size: ${({ theme }) => theme.styles.fontSizes.s14};
  font-weight: ${({ theme }) => theme.styles.fontWeights.medium};
  grid-template-rows: [add-icon] min-content [trigger-text] 1fr [chevron-icon] min-content;
  line-height: ${({ theme }) => theme.spacing.values.base};
  border: solid ${({ theme }) => theme.spacing.values.single} #bdbdbd;
  width: fit-content;
`;

export const TriggerWrapper = styled.div`
  background: #fff;
  border: none;
  display: flex;
  flex: 1 1 auto;
  justify-content: end;
`;

export const SELECT_TRIGGER_DATA_TEST = {
  button: 'insight-select-button-trigger',
};

export const Trigger = forwardRef<HTMLButtonElement, InsightSelectTriggerProps>(
  ({ toggleDropdown, isDisabled, placeholder = '' }, ref) => {
    const { t } = useTranslation();
    const TOOLTIP_TEXT = t('insights.select.tooltip');

    return (
      <Tooltip isEnabled={isDisabled} tooltipContent={TOOLTIP_TEXT} placement={TipPlacement.Left}>
        <TriggerButton
          ref={ref}
          onClick={toggleDropdown}
          isDisabled={isDisabled}
          data-test={SELECT_TRIGGER_DATA_TEST.button}
        >
          <Add16 />
          <span>{placeholder}</span>
          <ChevronDown height={16} width={16} />
        </TriggerButton>
      </Tooltip>
    );
  },
);
